import { Card, Grid, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Title from "../../components/ReusableComponents/title";
import "../../assets/css/accountanalysis.scss";
import HeadAndDesc from "../../components/ReusableComponents/HeadAndDesc";
import BalanceCurve from "./../../components/Charts/BalanceCurveChart";
import ProfitlossChart from "../../components/Charts/ProfitLossChart";
import FinalEvalTable from "../../components/AccountAnalysis/FinalEvalTable";
import { dollarUS } from "../../utilities/formatters";
import { fetchAccountObjectives } from "../../store/reducers/dashboardReducer";

const General = ({ data }) => {
  const upIcon = () => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.25 13.6C9.25 14.0142 9.58579 14.35 10 14.35C10.4142 14.35 10.75 14.0142 10.75 13.6H9.25ZM5.86731 8.75204C5.57573 9.04624 5.57784 9.52111 5.87204 9.81269C6.16624 10.1043 6.64111 10.1022 6.93269 9.80796L5.86731 8.75204ZM7.65806 8.01066L8.19075 8.53862L7.65806 8.01066ZM12.3419 8.01066L12.8746 7.4827V7.4827L12.3419 8.01066ZM13.0673 9.80796C13.3589 10.1022 13.8338 10.1043 14.128 9.81269C14.4222 9.52111 14.4243 9.04624 14.1327 8.75204L13.0673 9.80796ZM9.7744 6.41432L9.67957 5.67034L9.67957 5.67034L9.7744 6.41432ZM10.2256 6.41432L10.3204 5.67034L10.3204 5.67034L10.2256 6.41432ZM10.75 6.41432C10.75 6.00011 10.4142 5.66432 10 5.66432C9.58579 5.66432 9.25 6.00011 9.25 6.41432H10.75ZM18.25 10C18.25 14.5563 14.5563 18.25 10 18.25V19.75C15.3848 19.75 19.75 15.3848 19.75 10H18.25ZM10 18.25C5.44365 18.25 1.75 14.5563 1.75 10H0.25C0.25 15.3848 4.61522 19.75 10 19.75V18.25ZM1.75 10C1.75 5.44365 5.44365 1.75 10 1.75V0.25C4.61522 0.25 0.25 4.61522 0.25 10H1.75ZM10 1.75C14.5563 1.75 18.25 5.44365 18.25 10H19.75C19.75 4.61522 15.3848 0.25 10 0.25V1.75ZM10.75 13.6V7.12H9.25V13.6H10.75ZM6.93269 9.80796L8.19075 8.53862L7.12537 7.4827L5.86731 8.75204L6.93269 9.80796ZM11.8092 8.53862L13.0673 9.80796L14.1327 8.75204L12.8746 7.4827L11.8092 8.53862ZM8.19075 8.53862C8.70481 8.01996 9.04654 7.67678 9.3328 7.44688C9.60723 7.22649 9.75704 7.1726 9.86923 7.1583L9.67957 5.67034C9.18035 5.73397 8.77362 5.97212 8.39356 6.27735C8.02533 6.57307 7.6146 6.98909 7.12537 7.4827L8.19075 8.53862ZM12.8746 7.4827C12.3854 6.98909 11.9747 6.57307 11.6064 6.27735C11.2264 5.97212 10.8197 5.73397 10.3204 5.67034L10.1308 7.1583C10.243 7.1726 10.3928 7.22649 10.6672 7.44688C10.9535 7.67678 11.2952 8.01996 11.8092 8.53862L12.8746 7.4827ZM9.86923 7.1583C9.95607 7.14723 10.0439 7.14723 10.1308 7.1583L10.3204 5.67034C10.1077 5.64322 9.89234 5.64322 9.67957 5.67034L9.86923 7.1583ZM10.75 7.12V6.41432H9.25V7.12H10.75Z"
          fill="#0CCE6B"
        />
      </svg>
    );
  };
  const downIcon = () => {
    return (
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.25 5.5C9.25 5.08579 8.91421 4.75 8.5 4.75C8.08579 4.75 7.75 5.08579 7.75 5.5H9.25ZM12.0327 9.62796C12.3243 9.33376 12.3222 8.85889 12.028 8.56731C11.7338 8.27573 11.2589 8.27784 10.9673 8.57204L12.0327 9.62796ZM10.4516 10.1578L10.9843 10.6857L10.4516 10.1578ZM6.54839 10.1578L6.01569 10.6857L6.54839 10.1578ZM6.03269 8.57204C5.74111 8.27784 5.26624 8.27573 4.97204 8.56731C4.67784 8.85889 4.67573 9.33376 4.96731 9.62796L6.03269 8.57204ZM8.688 11.4881L8.78283 12.232L8.78283 12.232L8.688 11.4881ZM8.312 11.4881L8.21717 12.232L8.21717 12.232L8.312 11.4881ZM15.25 8.5C15.25 12.2279 12.2279 15.25 8.5 15.25V16.75C13.0563 16.75 16.75 13.0563 16.75 8.5H15.25ZM8.5 15.25C4.77208 15.25 1.75 12.2279 1.75 8.5H0.25C0.25 13.0563 3.94365 16.75 8.5 16.75V15.25ZM1.75 8.5C1.75 4.77208 4.77208 1.75 8.5 1.75V0.25C3.94365 0.25 0.25 3.94365 0.25 8.5H1.75ZM8.5 1.75C12.2279 1.75 15.25 4.77208 15.25 8.5H16.75C16.75 3.94365 13.0563 0.25 8.5 0.25V1.75ZM7.75 5.5V10.9H9.25V5.5H7.75ZM10.9673 8.57204L9.91892 9.62982L10.9843 10.6857L12.0327 9.62796L10.9673 8.57204ZM7.08108 9.62982L6.03269 8.57204L4.96731 9.62796L6.01569 10.6857L7.08108 9.62982ZM9.91892 9.62982C9.48848 10.0641 9.20945 10.344 8.97773 10.5301C8.75784 10.7067 8.65441 10.7363 8.59317 10.7441L8.78283 12.232C9.2311 12.1749 9.59145 11.9611 9.91697 11.6997C10.2307 11.4478 10.5787 11.095 10.9843 10.6857L9.91892 9.62982ZM6.01569 10.6857C6.42131 11.095 6.76934 11.4478 7.08303 11.6997C7.40855 11.9611 7.7689 12.1749 8.21717 12.232L8.40683 10.7441C8.34559 10.7363 8.24216 10.7067 8.02227 10.5301C7.79055 10.344 7.51152 10.0641 7.08108 9.62982L6.01569 10.6857ZM8.59317 10.7441C8.56223 10.748 8.53111 10.75 8.5 10.75V12.25C8.59447 12.25 8.68893 12.244 8.78283 12.232L8.59317 10.7441ZM8.5 10.75C8.46889 10.75 8.43777 10.748 8.40683 10.7441L8.21717 12.232C8.31107 12.244 8.40553 12.25 8.5 12.25V10.75ZM7.75 10.9V11.5H9.25V10.9H7.75Z"
          fill="#FD504F"
        />
      </svg>
    );
  };
  const [Objectives, setObjectives] = useState(false);
  const dispatch = useDispatch();
  const HeadAndDescWrapper = (props) => {
    return (
      <Grid item xs={3}>
        <HeadAndDesc {...props} HeadAndSubClassName={"headAndDescBox"} />
      </Grid>
    );
  };
  const HeadAndDescWrapper2 = (props) => {
    return (
      <Grid item xs={12} paddingTop={"0px"} sx={{ paddingTop: "0px" }}>
        <HeadAndDesc {...props} HeadAndSubClassName={"headAndDescBox2"} />
      </Grid>
    );
  };

  useEffect(() => {
    if (data && data.Basic_info.login_id) {
      dispatch(fetchAccountObjectives(data.Basic_info.login_id, data.Basic_info.platform))
        .then((data) => {
          setObjectives(data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [data, dispatch]);

  return (
    <Grid container item className="general-ctn" spacing={2} xs={12}>
      <Grid item xs={12} md={6}>
        <Card className="card-csc">
          <Title six>Balance Curve</Title>
          {/*<BalanceCurve data={data && data.Basic_info.balance_equity_history} />*/}
          <BalanceCurve login_id={data && data.Basic_info.login_id} />
          {/* <BalanceChart PerformanceChart={data && data.Basic_info.balance_equity_history}/> */}
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card className="card-csc">
          <Title six>Average profit / Average loss</Title>
          <ProfitlossChart
            data={
              data && [
                data.general_statistics.Average_profit,
                data.general_statistics.Average_loss,
              ]
            }
          />
        </Card>
      </Grid>
      <Grid item xs={12} md={8}>
        <Card className="card-csc" xs={12}>
          <Typography className="title-h" component={"h6"}>
            Basic Information
          </Typography>
          <Grid className="basic"  container spacing={3} xs={12}>
            <HeadAndDescWrapper
              HeadTitle="Log In Id"
              SubTitle={data && data.Basic_info.login_id}
            />
            <HeadAndDescWrapper
              HeadTitle="Account Size"
              SubTitle={data && data.Basic_info.account_size}
            />
            <HeadAndDescWrapper
              HeadTitle="Start Date"
              SubTitle={data && data.Basic_info.start_date}
            />
            <HeadAndDescWrapper
              HeadTitle="End Date"
              SubTitle={data && data.Basic_info.end_date}
            />
          </Grid>
          <Typography className="title-h" component={"h6"} marginTop={"40px"}>
            Final Evaluation
          </Typography>
          <FinalEvalTable data={data && data} Objectives={Objectives} />
        </Card>
      </Grid>
      <Grid item xs={12} md={4}>
        <Card
          className="card-csc"
          style={{
            gap: "10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "baseline",
          }}
        >
          <Typography className="title-h" component={"h6"}>
            General Statistics
          </Typography>
          <Grid
            container
            xs={12}
            spacing={3}
            className="generalStatistics_wrapper"
          >
            <div style={{ display: "flex", width: "100%", gap: "10px" , alignItems:"center" }}>
              <svg
               className="ticksvg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1_11157)">
                  <path
                    d="M12.75 6.75L10.2231 9.57238C9.22181 10.6908 8.72115 11.25 8.0625 11.25C7.40385 11.25 6.90319 10.6908 5.90188 9.57238L5.25 8.84427M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1_11157">
                    <rect width="18" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <HeadAndDescWrapper2
                HeadTitle="Result"
                SubTitle={
                  data &&
                  dollarUS(Number(data.general_statistics.result).toFixed(2))
                }
                SubTitleClass={
                  data && data.general_statistics.result >= 0
                    ? "Positive"
                    : "Negative"
                }
              />
            </div>
            <div style={{ display: "flex", width: "100%", gap: "10px" , alignItems:"center" }}>
              {data && data.general_statistics.Average_profit >= 0
                ? upIcon()
                : downIcon()}
              <HeadAndDescWrapper2
                HeadTitle="Average Profit"
                SubTitle={
                  data &&
                  dollarUS(
                    data &&
                      Number(data.general_statistics.Average_profit).toFixed(2)
                  )
                }
                SubTitleClass={
                  data && data.general_statistics.Average_profit >= 0
                    ? "Positive"
                    : "Negative"
                }
              />
            </div>
            <div style={{ display: "flex", width: "100%", gap: "10px" , alignItems:"center" }}>
              {data && data.general_statistics.max_profit >= 0
                ? upIcon()
                : downIcon()}
              <HeadAndDescWrapper2
                HeadTitle="Max Profit"
                SubTitle={
                  data &&
                  dollarUS(
                    Number(data.general_statistics.max_profit).toFixed(2)
                  )
                }
                SubTitleClass="Positive"
              />
            </div>
            <div style={{ display: "flex", width: "100%", gap: "10px" , alignItems:"center" }}>
              <svg
              className="ticksvg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.25 11.1429L6.34525 8.91007C6.89845 7.7823 8.52438 7.83738 9 9C9.47562 10.1626 11.1015 10.2177 11.6548 9.08993L12.75 6.85714M9 15.75C6.1877 15.75 4.78155 15.75 3.79581 15.0338C3.47745 14.8025 3.19748 14.5225 2.96619 14.2042C2.25 13.2184 2.25 11.8123 2.25 9C2.25 6.1877 2.25 4.78155 2.96619 3.79581C3.19748 3.47745 3.47745 3.19748 3.79581 2.96619C4.78155 2.25 6.1877 2.25 9 2.25C11.8123 2.25 13.2184 2.25 14.2042 2.96619C14.5225 3.19748 14.8025 3.47745 15.0338 3.79581C15.75 4.78155 15.75 6.1877 15.75 9C15.75 11.8123 15.75 13.2184 15.0338 14.2042C14.8025 14.5225 14.5225 14.8025 14.2042 15.0338C13.2184 15.75 11.8123 15.75 9 15.75Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>

              <HeadAndDescWrapper2
                HeadTitle="RRR"
                SubTitle={
                  data && Number(data.general_statistics.RRR).toFixed(2)
                }
              />
            </div>
            <div style={{ display: "flex", width: "100%", gap: "10px" , alignItems:"center" }}>
              {data && data.general_statistics.win_rate >= 0
                ? upIcon()
                : downIcon()}
              <HeadAndDescWrapper2
                HeadTitle="Win rate"
                SubTitle={
                  data && Number(data.general_statistics.win_rate).toFixed(2)
                }
                SubTitleClass={
                  data && data.general_statistics.win_rate >= 0
                    ? "Positive"
                    : "Negative"
                }
              />
            </div>
            <div style={{ display: "flex", width: "100%", gap: "10px" , alignItems:"center" }}>
              {data && data.general_statistics.Average_loss >= 0
                ? upIcon()
                : downIcon()}
              <HeadAndDescWrapper2
                HeadTitle="Average Loss"
                SubTitle={
                  data &&
                  dollarUS(
                    Number(data.general_statistics.Average_loss).toFixed(2)
                  )
                }
                SubTitleClass="Negative"
              />
            </div>
            <div style={{ display: "flex", width: "100%", gap: "10px" , alignItems:"center" }}>
              {data && data.general_statistics.max_loss >= 0
                ? upIcon()
                : downIcon()}
              <HeadAndDescWrapper2
                HeadTitle="Max Loss"
                SubTitle={
                  data &&
                  dollarUS(Number(data.general_statistics.max_loss).toFixed(2))
                }
                SubTitleClass="Negative"
              />
            </div>
            {/* <HeadAndDescWrapper2
              HeadTitle="Martingale Count"
              SubTitle={
                Objectives &&
                Objectives["martingale"] 
                Objectives["martingale"]["martingale_count"]
              }
              SubTitleClass={
                Objectives 
                Objectives["martingale"] 
                Objectives["martingale"]["status"].toLowerCase() === "failed"
                  ? "Negative"
                  : "Positive"
              }
            /> */}
          </Grid>
        </Card>
      </Grid>
      {/* <Grid item xs={12} md={6}>
        <Card className="card-csc"></Card>
      </Grid> */}
    </Grid>
  );
};

export default General;
